module.exports = __webpack_public_path__ + "img/bg-cant-find_medium.9f1b98e1.webp";